import type { SizingsSearch } from "@/components/types";
import type { SortMeta } from "@/composables/primevue/tables";
import type { LocationQuery } from "vue-router";

export function getSizingSortFromQuery(
  query: LocationQuery
): SortMeta[] | undefined {
  if (!query) return;

  if (!query.sort) return;

  return query.sort as [];
}

export function getSortQueryString(sort: SortMeta[]): string {
  return sort
    .map(s => `${s.field}:${s.order === 1 ? "asc" : "desc"}`)
    .join(",");
}

export function getSortMetaFromQuery(
  query: LocationQuery
): SortMeta[] | undefined {
  const sortString = query.sort as string; // Ensure you check for null/undefined if needed
  if (!sortString) return;

  return sortString.split(",").map(s => {
    const [field, order] = s.split(":");
    return {
      field,
      order: order === "asc" ? 1 : -1
    };
  });
}

export function getSizingsSearchFromQuery(query: LocationQuery): SizingsSearch {
  return {
    customerSearchText: (query?.customer as string) || "",
    globalSearchText: (query?.global as string) || "",
    ownerSearchText: (query?.owner as string) || "",
    wellSearchText: (query?.well as string) || "",
    dateRange: query.dateRange
      ? (query.dateRange as string).split(",").map(d => new Date(d))
      : []
  };
}
